module.exports = __webpack_public_path__ + "assets/img/home.757415a3.svg";